/**
 * 重置传入对象的各个属性值
 * @param obj
 */
export function resetObject(obj) {
    for (const objKey in obj) {
        try {
            obj[objKey] = Object.getPrototypeOf(obj[objKey]).constructor()
        } catch (e) {
            if (obj[objKey] === undefined) return
        }
    }
}